(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  window.addEventListener('load', e => {
    let details = document.querySelectorAll('details.footer-details');

    if(details.length > 0 && document.body.clientWidth > 749) {
      details.forEach(detail => {
        detail.querySelector('summary').click();
        !detail.querySelector('summary').classList.contains('no-click') && detail.querySelector('summary').classList.add('no-click');
      })
    }
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = document.getElementById('shopify-section-header');

    document.documentElement.style.setProperty(
      "--header-height",
      `${parseInt(
        this.header.offsetHeight
      )}px`
    );

    this.root_theme = document.querySelector(':root');
    this.predictiveSearch = this.querySelector('predictive-search');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', () => this.onScroll(), false);
    window.addEventListener('preventHeaderReveal', () => this.preventReveal = true);
    window.addEventListener('allowHeaderReveal', () => this.preventReveal = false);
    this.createObserver();
  }

  createObserver() {
    const observer = new IntersectionObserver(entries => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen || this.preventHide) return;

    if (scrollTop > this.currentScrollTop) {
      requestAnimationFrame(() => this.handleDirectionChange(scrollTop));
    } else {
      requestAnimationFrame(() => this.handleUpScroll(scrollTop));
    }
    this.currentScrollTop = scrollTop;
  }

  handleDirectionChange(scrollTop) {
    if (scrollTop > this.headerBounds.bottom) this.hide();
  }

  handleUpScroll(scrollTop) {
    if (scrollTop > this.headerBounds.bottom && !this.preventReveal) {
      this.reveal();
    } else if (scrollTop <= this.headerBounds.top) {
      this.reset();
    }
  }

  hide() {
    this.root_theme.style.setProperty('--collection-nav-top', '0rem'); 
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    document.body.classList.add('header-is-hidden');
    document.body.classList.remove('header-is-visible');
    this.closeSearchModal();
    this.root_theme.style.setProperty('--sidebar-top', '-3rem'); 
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    document.body.classList.add('header-is-visible');
    document.body.classList.remove('header-is-hidden');
    this.root_theme.style.setProperty('--sidebar-top', '17rem'); 
    this.updateDynamicStyles();
  }

  reset() {
    this.root_theme.style.setProperty('--collection-nav-top', '0rem'); 
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    document.body.classList.remove('header-is-hidden', 'header-is-visible');
    this.root_theme.style.setProperty('--sidebar-top', '-2rem'); 
  }

  toggleHeaderVisibility(isVisible) {
    this.header.classList.toggle('shopify-section-header-hidden', !isVisible);
    this.header.classList.toggle('shopify-section-header-sticky', isVisible);
    document.body.classList.toggle('header-is-visible', isVisible);
    document.body.classList.toggle('header-is-hidden', !isVisible);
  }

  updateDynamicStyles() {
    this.root_theme.style.setProperty('--collection-nav-top', window.innerWidth >= 750 ? '15rem' : '4.8rem');
  }

  closeSearchModal() {
    const searchModal = this.header.querySelector('details-modal');
    searchModal && searchModal.close(false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.removeEventListener('preventHeaderReveal', () => this.preventReveal = true);
  }
}

customElements.define('sticky-header', StickyHeader);


  document.addEventListener('shopify:block:select', e => {
  	let parentDetails = e.target.closest('details');

  	if (parentDetails) {
  		parentDetails.open = true;
  	}

  	let megaBlock = e.target.classList.contains('mega-menu__promo-item')
  	if (megaBlock && megaBlock != e.target) {
  		document.querySelectorAll('.mega-menu').forEach(item => {
  			item.style.pointerEvents = 'none';
  		})
  	}
  });

  document.addEventListener('shopify:block:deselect', function(e) {
  	let parentDetails = e.target.closest('details');
  	let megaBlock = e.target.classList.contains('mega-menu__promo-item')
  	if (megaBlock && megaBlock != e.target) {
  		document.querySelectorAll('.mega-menu').forEach(item => {
  			if (parentDetails) {
  				parentDetails.open = false;
  			}
  			item.style.pointerEvents = 'all';
  		})
  	}
  });

  } catch(e) { console.error(e); }
})();
})();
